"use strict";
import './stat-persons.less';

App.Pages.StatPersons = class StatPersons extends PF.Page
{

	static get options()
	{
		return {
			rights: {
				user: true
			},
			path: '/stat-persons',
			nameRu: 'Уникальные лица',
		};
	}

	static get template()
	{
		//language=HTML
		return `
			<div class="page navbar-fixed">

				<div class="page-content ptr-content" pf="pageContent">

					<div class="page-header">
						<h3 pf="stellaName">Уникальные лица</h3>
					</div>

					<form class="filterForm" pf="form">
						<div class="row resizable">
							<div class="col-50">
								<div pf="elements"></div>
							</div>
							<div class="col-50">
								<input pf="searchPerson"/>
							</div>
						</div>
						<div class="row resizable">
							<div class="col-65">
								<div pf="preset"></div>
							</div>
							<div class="col-15">
								<input pf="dates"/>
							</div>
							<div class="col-20">
								<input pf="similarity"/>								
							</div>
						</div>
					</form>
					

					<div class="row resizable">
						<div class="col-70">
							
							<div class="card" style="padding:0;" pf="list"></div>

						</div>
						<div class="col-30">
							<div pf="plots">
								<div class="card" pf="chartBlockEmotion"></div>
								<div class="card" pf="chartTopTen"></div>
							</div>
							
							<div class="preloader-wrapper" pf="preloader" style="width: fit-content; margin: auto;">
								<div class="preloader" style="margin:40px auto; ">
									<span class="preloader-inner">
										<span class="preloader-inner-gap"></span>
										<span class="preloader-inner-left">
											<span class="preloader-inner-half-circle"></span>
										</span>
										<span class="preloader-inner-right">
											<span class="preloader-inner-half-circle"></span>
										</span>
									</span>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

		`;

	}


	init()
	{
		super.init();
		this.loadStatus = true;
		this.errorStatus = false;

		this.bindDom({ preloader: 'show' }, 'loadStatus');
		this.bindDom({ plots: 'show' }, ['loadStatus', 'errorStatus'], (l, e) => !l && !e);

		this.statFilters = new PF.Model({ represent: "user-data/stat-filters-persons", saveOnModify: true, raw: { data: {} } });

		this.statFilters.onValue('options.loadStatus', 'loaded', () =>
		{
			this.form = new PF.Form({
				dom: { element: this.dom.form },
				model: this.statFilters,
				keyPrefix: 'data.',
				toastOnSave: false,
				fieldsConfig: {
					searchPerson: {
						class: PF.Field.String,
						label: 'Поиск по uuid:',
					},
					elements: {
						class: PF.Field.TreeMultiSelect,
						label: 'Выберете стелу:',
						includeRoot: false,
						types: {
							root: {
								model: new PF.Model({
									raw: {
										districts: this.statFilters.options.dicts.districts
									}
								}),
								childsKey: 'districts',
							},
							district: {
								childsKey: 'stellas',
								itemClass: ListDistrict
							},
							stella: {
								selectable: true,
								key: 'data.stellas',
								modelsConfig: {
									deletePolicy: 'delete'
								},
							},
						},
						simpleTitle: (count) =>
						{
							Util.sleep(2).then(() =>
							{
								if (count < 4 && count > 0)
								{
									let stellas = this.statFilters.data.stellas;
									let t = Util.spell(count, ['', 'Выбрана:', 'Выбраны:', 'Выбраны:']);
									for (let i = 0; i < stellas.size; i++)
									{
										if (i === 0)
										{
											t += ` "${stellas[i].name}"`;
										} else
										{
											t += `, "${stellas[i].name}"`;
										}
									}
									this.statFilters.options.form.fields.elements.simpleTitleText = t;
								}
							});
							return `Выбрано ${Util.spell(count, ['', '@{v} значение', '@{v} значения', '@{v} значений'])}`;
						},

						// class: PF.Field.MultiSelect,
						// label: 'Выберете район:',
						// includeRoot: false,
						// key: 'districts',
						// checkConfig: {
						// 	// allowNull: true,
						// 	deletePolicy: 'delete',
						// 	listConfig: {
						// 		addable: false,
						// 		modelsConfig: {
						// 			// represent: 'district/Manage',
						// 			represent: 'pivo',
						// 			representUrl: '/demo/plot/district',
						// 		},
						// 		itemClass: ListDistrict
						// 	},
						// },
					},
					dateDiapason: {
						class: PF.Field.DateDiapasonWithPreset,
						presetConfig: {
							dom: {
								element: this.dom.preset
							},
							key: 'data.diapasonPreset',
						},
						datesConfig: {
							dom: {
								element: this.dom.dates
							},
							startKey: 'data.calendar.start',
							finishKey: 'data.calendar.finish',
						},
					},
					similarity: {
						class: PF.Field.Float,
						label: 'Совпадение от(%)',
						minValue: 0,
						maxValue: 100,
					}
				}
			});

			this.initList();

			// понизить порог до минимума при поиске персоны по ид
			this.statFilters.onChange('data.searchPerson', () =>
			{
				if (this.statFilters.get('data.searchPerson') !== "")
				{
					this.statFilters.setData('data.similarity', 0.1, true);
				} else {
					this.statFilters.setData('data.similarity', null, true);
				}
			});

			this.statFilters.on('save-success', () =>
			{
				// this.initList();
				this.loadPlots();
				this.listPersons.models.reload();
				this.listPersons.calc("title", "models.count", (count) => isFinite(count) ? `Найдено ${count} ${Util.spell(count, ['', 'персона', 'персоны', 'персон'])}` : ``);
			}, true);

		}); //statFilters options.loadStatus

	}


	initList()
	{
		this.listPersons = new PF.List({
			dom: {
				element: this.dom.list,
				scrollTarget: this.dom.pageContent,
			},
			searchable: false,
			modelsConfig: {
				represent: 'person/stat',
				limit: 10,
			},
			itemClass: Person,
		});
	}

	//Статистика

	loadPlots()
	{
		this.loadStatus = true;
		this.dom.chartTopTen.empty();
		this.dom.chartBlockEmotion.empty();
		app.request('/demo/plot/stat-persons', [], (response) =>
		{
			app.toast("Ответ получен.");
			this.loadStatus = false;
			this.response = Util.isJsonString(response) ? JSON.parse(response) : response;
			this.chekPoint = 0;
			if (this.response.status != 'FAIL')
			{
				this.errorStatus = false;
				this.creatCharts();
			}
			else
			{
				app.toast("Нет данных.");
				this.errorStatus = true;
			}
		});

	} //loadPlots

	creatCharts()
	{
		let option = {
			chart: {
				plotBackgroundColor: null,
				plotBorderWidth: null,
				plotShadow: false,
				type: 'pie'
			},
			tooltip: {
				pointFormat: '<b>{point.percentage:.1f}%</b>'
			},
			accessibility: {
				point: {
					valueSuffix: '%'
				}
			},
			plotOptions: {
				pie: {
					allowPointSelect: true,
					cursor: 'pointer',
					dataLabels: {
						enabled: true,
						format: '{point.percentage:.1f} %'
					},
					showInLegend: true
				}
			}
		};

		this.emotions = new PF.Charts.Highcharts({
			dom: { element: this.dom.chartBlockEmotion },
			title: {
				useHTML: true,
				//language=HTML
				text: `<h4>Соотношение эмоций</h4>`,
				align: 'left',
			},
			series: [this.response.data.avgEmotions.series],
			...option
		});

		this.topTen = new PF.Charts.Highcharts({
			dom: { element: this.dom.chartTopTen },
			title: {
				useHTML: true,
				//language=HTML
				text: `<h4>Топ-10 популярных мест</h4>`,
				align: 'left',
			},
			series: [this.response.data.topTenByStellas.series],
			...option
		});
	}

};

class Person extends PF.List.Item
{

	get renderer()
	{
		//language=HTML
		return `
			<li pf="item">
				<a href="" class=" item-content item-link" pf="link">
					<div class="item-inner person-inner">
						<div class="item-title" style="width: 80%">
							<div class="person-data">
								<div class="img">
									<img src="@{model.personImgs.0.file.local_url}" style="width: 60px" pf="img">
								</div>
								<div class="info">
									uuid: <span>@{model.id}</span><br/>
									Возраст: <span>@{model.age}</span><br/>
									Пол: <span>@{model.gender.name}</span><br/>
								</div>
							</div>
						</div>
						<div class="item-after">
						</div>
						<div class="item-subtitle">							
							Детекций: @{model.detections.size}
						</div>
					</div>
				</a>
			</li>
		`;
	}

	onRender()
	{
		super.onRender();
		this.dom.link.on("click", () =>
		{
			app.pageParams.setData('id', this.model.id);
			app.pageParams.setData('return', 'persons');
			app.pageParams.setData('similarity', null);
			app.router.navigate('/stat-person');
		});
	}
}

class ListDistrict extends PF.Field.TreeMultiSelect.Item
{
	static get options()
	{
		return {
			title: `@{model.name}`,
			formConfig: {
				notModifyBehavior: 'hide',
				fieldsConfig: {
					name: {
						class: PF.Field.String,
						label: 'name',
					}
				}
			}
		};
	}

	get itemInner()
	{
		//language=HTML 
		return `
			<div class="item-inner">
				<div class="item-title">
					@{model.name}<br/>
				</div>
				<div class="item-after">
					Количество стел: @{model.stellas.count}
				</div>
			</div>`;
	}
}